import app from 'apprun';
import { __ } from './Txlat';

export default function PageControl({ page, total, size, event = 'gotoPage', type, isMlsDeleted }) {

  const pageCount = (total % size) === 0 ? Math.floor(total / size) : Math.floor(total / size) + 1;
  page = parseInt(page);

  let label = '';

  if (total > 0) {
    if (pageCount === page) {
      label = `${(page - 1) * size + 1} - ${total} ${__('of')} ${total}`;
    } else {
      label = `${(page - 1) * size + 1} - ${page * size} ${__('of')} ${total}`;
    }
  }

  if (isMlsDeleted) {
    if (total) {
      return (
        <span><b>{__('The listing you are looking for no longer exists.')}</b><br></br><b>{__('Similar Listings')}</b></span>
      );
    } else {
      return (
        <span><b>{__('The listing you are looking for no longer exists.')}</b></span>
      );
    }
  } else {
    if (total) {
      return (
        <span>
          {type === 'agentnearby' ? <div><b>{__('No result, here are nearby agents.')}</b></div> : ''}

          <style>{'.cursor-pointer {cursor: pointer}'}</style>
          <b>
            <a class="cursor-pointer" $onclick={[event, page - 1]} style={page > 1 && total > 0 ? 'color: #ea002a;' : 'display:none'}>
              <i class="fas fa-arrow-alt-circle-left"></i></a>
            &nbsp;{label}&nbsp;{__('results')}&nbsp;
            <a class="cursor-pointer" $onclick={[event, page + 1]} style={page < pageCount ? 'color: #ea002a;' : 'display:none'}>
              <i class="fas fa-arrow-alt-circle-right"></i></a>
          </b>
        </span>
      );
    } else {
      let emptyResult = '';
      switch (type) {
        case 'property': emptyResult = __('Sorry, no Properties found. Please refine your search.'); break;
        case 'agent': emptyResult = __('Please zoom out on the map to include more results or change your search criteria.'); break;
        case 'agency': emptyResult = __('Sorry, no Offices found. Please refine your search.'); break;
        default: emptyResult = ''; break;
      }
      return (
        <span><b>{emptyResult}</b></span>
      );
    }
  }
}
